import React from 'react'

const MobileNavbar = () => {

  let attendeeId = window.initialState && window.initialState.isAttendeeLoggedIn ? window.initialState.attendee.attendeeId : "attendeeId"
  
  const navItemsList = ['mobileNavItem1', 'mobileNavItem2', 'mobileNavItem3', 'mobileNavItem4', 'mobileNavItem5', 'mobileNavItem6', 'mobileNavItem7', 'mobileNavItem8'];

  window.onclick = function (event) {
    if ( event.target.id !== 'mobechoTec14' && event.target.id !== 'mobileNavItem4' && event.target.id !== 'mobileDropdown' && event.target.id !== 'echoTec14' &&  event.target.id !== 'humburgerIcon' ) {
      var x = document.getElementById('mobileNav');
      x.classList.add('hidden');
    }  
  }
  
  function toggleDropdown(e, id, zonExib) {
    e.preventDefault();
    if (document.getElementById(id).classList.contains("hidden")) {
      document.getElementById(id).classList.remove("hidden");
      document.getElementById('dropdownIcon').style.transform = "rotate(180deg)"
      for (var i = 0; i < navItemsList.length; i++) {
        if (navItemsList[i] != zonExib) {
          document.getElementById(navItemsList[i]).classList.add("hidden");
          document.getElementById('mobileDropdown').classList.remove("hidden");
        }
      }
    } else {
      document.getElementById(id).classList.add("hidden")
      document.getElementById('dropdownIcon').style.transform = "rotate(360deg)"
      for (var i = 0; i < navItemsList.length; i++) {
        if (navItemsList[i] != zonExib) {
          document.getElementById(navItemsList[i]).classList.remove("hidden");
          document.getElementById('mobileDropdown').classList.remove("hidden");
        }
      }
    }
  }

  return (
    <div id='mobileDropdown' className='bg-white  text-[1.2rem]  absolute top-[9rem]  w-[14rem] right-0 z-50'>
      <ul className='flex flex-col my-12 items-center justiy-center h-full'>
        <li id="mobileNavItem1" className=' h-20 text-purple hover:text-lightpurple'>
          <a href='https://reg.oneventseries.intel.com/flow/intel/innovation2022/attendee-portal/page/agenda' className=' text-[1.2rem] hover:underline'>
            My Agenda
          </a>
        </li>
        <li id="mobileNavItem2" className=' h-20 text-purple hover:text-lightpurple'>
          <a href='https://reg.oneventseries.intel.com/flow/intel/innovation2022/attendee-portal/page/sessioncatalog' className=' text-[1.2rem] hover:underline'>
            Catalog
          </a>
        </li>
        <li id="mobileNavItem3" className=' h-20 text-purple hover:text-lightpurple'>
          <a href={`https://intelinnovation.braindate.com/?utm_source=eventbase&utm_medium=integration&ext-id=${attendeeId}`} className=' text-[1.2rem] hover:underline'>
            Braindate
          </a>
        </li>
        <li id="mobileNavItem4" className=' h-20 text-purple hover:text-lightpurple'>
          <a href={`https://reg.oneventseries.intel.com/flow/intel/innovation2022/attendee-portal/page/surveys`} className=' text-[1.2rem] hover:underline'>
            Surveys
          </a>
        </li>
      </ul>

    </div>
  )
}

export default MobileNavbar
